<template>
  <div class="jobs-page">
    <banner title="职位招聘" />
    <section class="jobs-panel">
      <div class="job-list" v-if="jobs.length">
        <article class="job-card" v-for="job in jobs" :key="job.id || job.title">
          <div class="job-head">
            <h3>{{ job.title }}</h3>
            <button type="button" class="apply-button" @click="applyJob(job.id)">
              <span>申请</span>
              <i class="el-icon-right"></i>
            </button>
          </div>
          <div class="job-meta">
            <span>发布日期：{{ job.publishDate }}</span>
            <span>有效日期：{{ job.expiryDate }}</span>
          </div>
          <el-collapse>
            <el-collapse-item title="职位描述" name="1">
              <div class="job-description" v-html="job.description"></div>
            </el-collapse-item>
          </el-collapse>
        </article>
      </div>
      <div class="empty-state" v-else>
        <i class="el-icon-office-building"></i>
        <p>暂无招聘职位</p>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      jobs: [
        {
          title: "java开发工程师",
          publishDate: "2020-01-01",
          expiryDate: "2020-01-31",
          description:
            "1.负责公司产品的开发工作，包括需求分析、系统设计、编码、测试、文档等工作；2.负责公司产品的维护工作，包括故障分析、故障修复、版本发布等工作；3.负责公司产品的技术支持工作，包括客户问题分析、问题解决、客户培训等工作。"
        },
        {
          title: "前端开发工程师",
          publishDate: "2020-01-01",
          expiryDate: "2020-01-31",
          description:
            "1.负责公司产品前端功能开发与维护；2.配合产品与后端完成页面联调；3.参与前端体验优化、组件沉淀与文档编写。"
        }
      ]
    };
  },
  methods: {
    loadJobs() {
      this.$http
        .get("Jobs")
        .then(response => {
          this.jobs = response.result || [];
        })
        .catch(() => {});
    },
    applyJob() {}
  },
  created() {
    this.loadJobs();
  }
};
</script>

<style lang="scss" scoped>
.jobs-page {
  min-height: 100%;
  background: #eef4f8;
}

.jobs-panel {
  width: min(1180px, 92%);
  margin: -34px auto 56px;
  padding: 36px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 2;
}

.job-list {
  display: grid;
  gap: 18px;
}

.job-card {
  padding: 24px;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
}

.job-head {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
}

.job-head h3 {
  color: #142235;
  font-size: 22px;
  line-height: 1.45;
}

.apply-button {
  min-width: 88px;
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(44, 172, 226, 0.44);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #f7fbfe;
  color: #075b94;
  font-weight: 700;
  cursor: pointer;
}

.job-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: 12px 0 16px;
  color: #7d8fa3;
  font-size: 14px;
}

.job-description {
  color: #465a70;
  font-size: 14px;
  line-height: 1.8;
}

.empty-state {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7d8fa3;
}

.empty-state i {
  font-size: 42px;
  color: #b7c7d8;
}

.empty-state p {
  margin-top: 12px;
  font-size: 16px;
}

:deep(.el-collapse) {
  border-top: 1px solid #e3edf5;
  border-bottom: 0;
}

:deep(.el-collapse-item__header) {
  color: #142235;
  font-weight: 700;
}

@media (max-width: 680px) {
  .jobs-panel {
    width: 94%;
    padding: 22px 16px 34px;
  }

  .job-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
